/* TEST HOOK: ?mh_weekend=1 forces the weekend state, only on an unpublished theme or in the theme editor (window.mhCfg.test, set in theme.liquid); never on the published shop. Weekend elements show only when window.mhCfg.pl (country = Poland).
   Weekend free delivery window, Europe/Warsaw: Friday 16:00 to Sunday 23:59 (Mon 00:00 to Fri 15:59 = weekday state).
   [data-mh-weekend] blocks show only in the window, [data-mh-weekday] only outside it. The visitor's own clock zone is
   never trusted: Intl reads Warsaw time. Re-checked every minute. No JS = weekday state. window.mhIsWeekend() is shared with mh-delivery.js. */
(function () {
  function warsaw() {
    var p = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Warsaw', weekday: 'short', hour: '2-digit', hourCycle: 'h23' }).formatToParts(new Date()), o = {};
    p.forEach(function (x) { o[x.type] = x.value; });
    return { d: o.weekday, h: parseInt(o.hour, 10) % 24 };
  }
  window.mhIsWeekend = function () { var c = window.mhCfg || {}; if (!c.pl) { return false; } if (c.test && /[?&]mh_weekend=1\b/.test(location.search)) { return true; } var t = warsaw(); return t.d === 'Sat' || t.d === 'Sun' || (t.d === 'Fri' && t.h >= 16); };
  function apply() {
    var on = window.mhIsWeekend();
    document.documentElement.classList.toggle('mh-weekend-on', on);
    document.querySelectorAll('[data-mh-weekend]').forEach(function (e) { e.hidden = !on; });
    document.querySelectorAll('[data-mh-weekday]').forEach(function (e) { e.hidden = on; });
  }
  apply(); setInterval(apply, 60000); document.addEventListener('visibilitychange', apply);
  document.addEventListener('DOMContentLoaded', apply);
  ['mh:content-loaded', 'mh:dialog-open', 'shopify:section:load'].forEach(function (n) { document.addEventListener(n, apply); });
})();
